/**
 * The metric + operator selects of a condition row.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Lifted out of ConditionRow so that file stays readable once the scoped and
 * default value editors both live there. Pure presentation — no state.
 */

import type { FC } from 'react';

import type { TagRuleCondition } from '@/hooks';

import { LIST_METRIC_FIELDS, OPERATORS } from '../../../constants';

const SELECT =
  'h-9 w-full rounded-md border border-input bg-background py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

export const MetricOperatorFields: FC<{
  condition: TagRuleCondition;
  onChange: (c: TagRuleCondition) => void;
  /** Selectable metric fields; defaults to the list stats columns. */
  fields?: ReadonlyArray<{ key: string; label: string }>;
}> = ({ condition, onChange, fields = LIST_METRIC_FIELDS }) => (
  <>
    <div className="min-w-0">
      <label className="mb-1 block text-xs font-medium text-muted-foreground">Metric</label>
      <select
        value={condition.field}
        onChange={(e) =>
          onChange({ ...condition, field: e.target.value as TagRuleCondition['field'] })
        }
        className={`${SELECT} min-w-0 px-3`}
        aria-label="Metric field"
      >
        {fields.map((f) => (
          <option key={f.key} value={f.key}>
            {f.label}
          </option>
        ))}
      </select>
    </div>
    <div>
      <label className="mb-1 block text-xs font-medium text-muted-foreground">Operator</label>
      <select
        value={condition.operator}
        onChange={(e) =>
          onChange({ ...condition, operator: e.target.value as TagRuleCondition['operator'] })
        }
        className={`${SELECT} px-2 text-center font-medium`}
        aria-label="Operator"
        title={OPERATORS.find((o) => o.op === condition.operator)?.title}
      >
        {OPERATORS.map((o) => (
          <option key={o.op} value={o.op}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  </>
);
